import { useCallback } from "react";
import { useMutation } from "react-query";
import { toast } from "sonner";
import { Dialog, Flex, Text, Button } from "@radix-ui/themes";
import { useSamplingApi } from "@/v2/entities/sampling/Sampling.api";

interface DeleteSampleFormDialogProps {
  open: boolean;
  onSuccess: () => void;
  onClose: () => void;
  formId?: number;
}

export function DeleteSampleFormDialog({
  open,
  onSuccess,
  onClose,
  formId,
}: DeleteSampleFormDialogProps) {
  const samplingApi = useSamplingApi();

  const { mutateAsync: deleteForm } = useMutation({
    mutationFn: samplingApi.deleteSampleForm,
  });

  const handleDelete = useCallback(async () => {
    if (!formId) return;
    const data = await deleteForm(formId);

    if (data === true) {
      toast("QA Scorecard deleted successfully");
      onSuccess();
    } else {
      toast.error(
        "Can't delete scorecard with active validation sets, please reach out to support"
      );
    }
    onClose();
  }, [deleteForm, onClose, formId, onSuccess]);

  return (
    <Dialog.Root open={open} onOpenChange={onClose}>
      <Dialog.Content>
        <Text size="4" weight="bold">
          Delete QA Scorecard?
        </Text>
        <Text
          size="2"
          color="gray"
          style={{
            margin: "16px 0",
            display: "block",
            whiteSpace: "pre-line",
          }}
        >
          This action cannot be undone. Are you sure you want to delete this QA
          Scorecard?
        </Text>
        <Flex gap="3" mt="4" justify="end">
          <Button variant="ghost" color="gray" onClick={onClose}>
            Cancel
          </Button>
          <Button color="red" onClick={handleDelete}>
            Delete
          </Button>
        </Flex>
      </Dialog.Content>
    </Dialog.Root>
  );
}
